import React from 'react';
import './WhyNetCup.css';

const WhyNetCup = () => {
  const reasons = [
    {
      title: 'İSO Uzmanlığı',
      description: 'Kalite, çevre, gıda ve bilgi güvenliği standartlarında deneyimli danışmanlık ve belgelendirme süreç desteği.'
    },
    {
      title: 'Süreç Odaklı Danışmanlık',
      description: 'Belge öncesi hazırlık, dokümantasyon ve denetim süreçlerinde işletmenize özel çözümler sunuyoruz.'
    },
    {
      title: 'Güncel Standartlar',
      description: 'İSO standartlarındaki güncellemeleri takip ediyor, işletmenizi güncel gerekliliklere göre yönlendiriyoruz.'
    }
  ];

  return (
    <section id="why-netcup" className="why-netcup">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Neden Bizi Tercih Etmelisiniz?</h2>
        </div>
        <div className="reasons-grid">
          {reasons.map((reason, index) => (
            <div key={index} className="reason-card">
              <h3 className="reason-title">{reason.title}</h3>
              <p className="reason-description">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyNetCup;
